import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialogData, GenericDialogResult, GenericDialogType, GenericDialogPayload } from './generic-dialog.model';
import { NOTES_MAX_LENGTH } from '@app/core/configs/dialog.config';

@Component({
    templateUrl: './generic-dialog.component.html',
    styleUrls: ['./generic-dialog.component.scss'],
    standalone: false
})
export class GenericDialogComponent {
  isConfirmChecked = false;
  notes = ''
  readonly notesMaxLength = NOTES_MAX_LENGTH

  constructor(
    private dialogRef: MatDialogRef<GenericDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GenericDialogData
  ) {
    this.notes = this.data.initialNotes || '';
  }

  get title() {
    return this.data.title;
  }
  get messageLines(): string[] {
    return Array.isArray(this.data.message) ? this.data.message : [this.data.message];
  }

  getIcon(type: GenericDialogType = GenericDialogType.INFO): string {
    switch (type) {
      case GenericDialogType.ERR: return 'error';
      case GenericDialogType.WARN: return 'warning';
      case GenericDialogType.SUCCESS: return 'check_circle';
      default: return 'info';
    }
  }

  onButtonClick(action: string) {
    if (action === 'confirm') {
      if (this.data.requireConfirmCheckbox && !this.isConfirmChecked) return;
      if(this.data.showNotesInput) {
        const payload: GenericDialogPayload = {
          notes: this.notes.trim() || ''
        }
        this.dialogRef.close(payload);
        return;
      }
      this.dialogRef.close(GenericDialogResult.Confirm);
    } else if (action === 'cancel' || action === 'close') {
      this.dialogRef.close(GenericDialogResult.Cancel);
    } else {
      // Keeping for custom actions
      this.dialogRef.close(action); 
    }
  }
}
